import React from 'react';
import { FavoriteIcon } from '@hz-design-system/web-ui';
import { ListingFavoriteIconProps } from '../types';
import Classes from './ListingFavoriteIcon.module.scss';

const ListingFavoriteIcon: React.FC<ListingFavoriteIconProps> = ({
  isFavorite,
  onFavorite,
  ariaLabel,
  descriptionElementId,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onFavorite?.();
  };

  return (
    <FavoriteIcon
      className={Classes['hz-Listing-image-favorite-icon']}
      isFavorite={isFavorite}
      // @ts-expect-error - onClick has incorrect signature, needs to be fixed in the FavoriteIcon component
      onClick={handleClick}
      ariaLabel={ariaLabel}
      aria-describedby={descriptionElementId}
      alwaysVisible
    />
  );
};

export default ListingFavoriteIcon;
